
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useFreeResponseContext } from "./FreeResponseContext";

interface FreeResponseCompletedProps {
  questions: any[];
  attempt: any;
  onBack?: () => void;
}

export function FreeResponseCompleted({ questions, attempt, onBack }: FreeResponseCompletedProps) {
  const { responses } = useFreeResponseContext();

  return (
    <ScrollArea className="h-[calc(100vh-100px)]">
      <div className="p-6">
        {onBack && (
          <Button variant="ghost" size="sm" className="mb-4" onClick={onBack}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        )}
        
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-[#1A1F2C] flex items-center">
            <CheckCircle2 className="h-5 w-5 mr-2 text-green-500" />
            Completed Assessment
          </h3>
          <p className="mt-2 text-[#8E9196]">
            Your responses have been submitted successfully.
          </p>
          
          <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm">
            Completed on {new Date(attempt.completed_at).toLocaleDateString()}
          </div>
        </div>
        
        <div className="space-y-6 mt-6">
          <h4 className="text-md font-semibold text-[#1A1F2C]">Your Submitted Responses:</h4>
          {questions.map((question, index) => (
            <div key={question.id} className="border border-[#E5DEFF] rounded-xl p-6 space-y-4 bg-[#F8F7FD]">
              <p className="font-medium text-[#1A1F2C]">{index + 1}. {question.question}</p>
              
              <div className="bg-white border border-gray-200 rounded-md p-4 text-[#1A1F2C]">
                {responses[question.id] || "No response provided"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </ScrollArea>
  );
}
